import { render, staticRenderFns } from "./Pcas.vue?vue&type=template&id=624bfc76&scoped=true"
import script from "./Pcas.vue?vue&type=script&lang=js"
export * from "./Pcas.vue?vue&type=script&lang=js"
import style0 from "./Pcas.vue?vue&type=style&index=0&id=624bfc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624bfc76",
  null
  
)

export default component.exports